import React, { useEffect, useState } from 'react';

//------Material UI-----/
import { makeStyles } from '@material-ui/core/styles';
import SchoolIcon from '@material-ui/icons/School';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

const TrainingItemCard = (props) => {
  const [toggle, setToggle] = useState(false);

  const handleChange = (event) => {
    setToggle(!toggle);

    if (toggle === false) {
      var itemToBeAdded = { modId: event.target.name, status: 'required' };
    } else if (toggle === true) {
      var itemToBeAdded = { modId: event.target.name, status: 'suggested' };
    }

    const index = props.modId.findIndex((p) => p.modId === itemToBeAdded.modId);

    if (index === -1) {
      props.modId.push(itemToBeAdded);
    } else {
      props.modId[index] = itemToBeAdded;
    }
  };

  const trainingDetailPush = (trainingDetails) => {
    props.history.push('/Dashboard/Training?pad=&id=' + trainingDetails);
  };

  console.log(props.trainingDetails)

  useEffect(() => {
    //if (props.status !== undefined) {
    if (props.status === 'required') {
      setToggle(true);
    } else {
      setToggle(false);
    }
    // }
  }, [props.status]);

  //------Modern Card Styling----//
  const useStyles = makeStyles((theme) => ({
    modernRoot: {
      borderRadius: 16,
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0 12px 40px rgba(0, 85, 162, 0.2)',
      },
    },
    root: {
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: '0 8px 25px rgba(0, 85, 162, 0.15)',
      },
    },
    media: {
      height: 160,
      position: 'relative',
    },
    statusBadge: {
      position: 'absolute',
      top: 8,
      right: 8,
      fontWeight: 600,
      fontSize: '0.7rem',
      borderRadius: 12,
      padding: '4px 12px',
    },
    durationBadge: {
      position: 'absolute',
      bottom: 8,
      left: 8,
      background: 'rgba(0,0,0,0.7)',
      color: 'white',
      padding: '4px 8px',
      borderRadius: 12,
      fontSize: '0.75rem',
      fontWeight: 500,
    },
    overlineTypography: {
      color: '#B5B5B5',
      fontFamily: 'Montserrat, sans-serif',
    },
    statusTypography: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 600,
    },
  titleTypography: {
      fontWeight: 600,
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '1.3em',
      paddingBottom: 12,
      color: theme.palette.type === 'dark' ? theme.palette.text.primary : '#1a237e',
      lineHeight: 1.3,
      height: 60,
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
    },
    descriptionTypography: {
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '1.1em',
      height: 100,
      paddingBottom: 10,
    },
    cardActions: {
      padding: '16px',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    },
    modernButton: {
      background: 'linear-gradient(45deg, #0055A2, #428BC9)',
      color: 'white',
      fontWeight: 600,
      borderRadius: 8,
      textTransform: 'none',
      padding: '8px 16px',
      '&:hover': {
        background: 'linear-gradient(45deg, #061739, #0055A2)',
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 15px rgba(0, 85, 162, 0.3)',
      },
    },
    button: {
      fontFamily: 'Montserrat, sans-serif',
    },
    toolbar: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(3),
    },
  }));

  const classes = useStyles();

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'completed': return '#4caf50';
      case 'required': return '#f44336';
      case 'in progress': return '#2196f3';
      case 'suggested': return '#ff9800';
      default: return '#9e9e9e';
    }
  };

  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Card className={props.modernStyle ? classes.modernRoot : classes.root}>
        <CardActionArea onClick={() => trainingDetailPush(props.trainingDetails)}>
          <div className={classes.media}>
            <CardMedia
              style={{ width: '100%', height: '100%' }}
              image={props.image || '/api/placeholder/300/160'}
              title={props.accessibleTitle}
            />
            {/* Status Badge */}
            <div 
              className={classes.statusBadge}
              style={{
                backgroundColor: getStatusColor(props.status),
                color: 'white'
              }}
            >
              {props.status || 'Available'}
            </div>
            {/* Duration Badge */}
            <div className={classes.durationBadge}>
              ⏱️ {props.timeEstimate}
            </div>
          </div>
          <CardContent style={{ padding: 16 }}>
            <Typography className={classes.titleTypography} variant="h6" component="h2">
              {props.title}
            </Typography>
            <Typography variant="body2" style={{ color: '#666', marginBottom: 12 }}>
              Comprehensive cybersecurity training module designed to enhance your security awareness.
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions className={classes.cardActions}>
          <div style={{ width: '100%' }}>
            {props.accessLevel === 'CompanyAdmin' || props.accessLevel === 'AccountAdmin' ? (
              <FormControlLabel
                style={{ fontSize: '12px', marginBottom: 8, width: '100%' }}
                control={
                  <Switch 
                    color="primary" 
                    checked={toggle} 
                    onChange={handleChange} 
                    name={props.trainingDetails}
                    size="small"
                  />
                }
                label="Required for organization"
              />
            ) : null}
            <Button
              className={props.modernStyle ? classes.modernButton : classes.button}
              variant={props.modernStyle ? "contained" : "text"}
              color={props.modernStyle ? "default" : "primary"}
              fullWidth
              startIcon={<SchoolIcon />}
              onClick={() => trainingDetailPush(props.trainingDetails)}
            >
              {props.modernStyle ? 'Take Training' : 'View this training'}
            </Button>
          </div>
        </CardActions>
      </Card>
    </Grid>
  );
};
export default TrainingItemCard;

//window.onunload = function () { window.scrollTo(0, 0);
//< Typography className = { classes.descriptionTypography } variant = "body2" color = "textSecondary" component = "p" >
//    { props.description }
//</Typography >
